// Import rank images
import crewlingImg from "../ranks/Crewling.png";
import woodImg from "../ranks/Wood.png";
import copperImg from "../ranks/Copper.png";
import bronzeImg from "../ranks/Bronze.png";
import silverImg from "../ranks/Silver.png";
import goldImg from "../ranks/Gold.png";
import diamondImg from "../ranks/Diamond.png";
import masterImg from "../ranks/Master.png";
import grandmasterImg from "../ranks/Grandmaster.png";
import amongusLordImg from "../ranks/amonguslord.png";

export const BASE_ELO = 1100;

export const RANKS = [
  { name: "Crewling",      min: 0,    color: "#8B8B8B", icon: crewlingImg },
  { name: "Wood",          min: 700,  color: "#8B4513", icon: woodImg },
  { name: "Copper",        min: 800,  color: "#B87333", icon: copperImg },
  { name: "Bronze",        min: 900,  color: "#CD7F32", icon: bronzeImg },
  { name: "Silver",        min: 1000, color: "#C0C0C0", icon: silverImg },
  { name: "Gold",          min: 1100, color: "#FFD700", icon: goldImg },
  { name: "Diamond",       min: 1200, color: "#B9F2FF", icon: diamondImg },
  { name: "Master",        min: 1350, color: "#EF5350", icon: masterImg },
  { name: "Grand Master",  min: 1500, color: "#CE93D8", icon: grandmasterImg },
  { name: "Among Us Lord", min: 1700, color: "#FFD700", icon: amongusLordImg },
];
